const isEducationDirectorAdminAssistant = (user: any) => {
  if (user?.roles?.includes('user') && user?.group?.name === 'EducationDirectorAdminAssistant') {
    return true;
  }

  return false;
};

export default isEducationDirectorAdminAssistant;
